import { Component, Input, OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';
import { Store } from '@ngrx/store';

import { TestNavigationService } from './../../../../../../services/test-navigation.service';
import { TestTakerService } from './../../../../../../services/test-taker.service';
import { HtmlService } from './../../../../../../services/html.service';
import * as fromRoot from '../../../../../../store/reducers';
import { ConfigHelper } from 'app/services/config.helper';

@Component({
    selector: 'end-of-test',
    template: require('./end-of-test.component.html'),
})
export class EndOfTestComponent implements OnInit, AfterViewInit {
    @Input() pictureResourceId: number;
    testLogoImageData: string;
    testTypeName: string = "[TestTypeName]";
    testTakerPhotoUrl: string;
    testTakerInfoSubscription: Subscription;
    testletIdSubscription: Subscription;
    isWebDelivery: boolean;

    private readonly endOfTestEventName: string = "tdp:end-of-test";

    constructor(
        private store: Store<fromRoot.State>,
        private testNavigationService: TestNavigationService,
        private testTakerService: TestTakerService,
        private htmlService: HtmlService,
        private changeDetectorRef: ChangeDetectorRef
    ) {
        this.isWebDelivery = ConfigHelper.isTdpMode(true);
    }

    ngOnInit() {
        if (ConfigHelper.isTdpMode(true)) {
            this.testNavigationService.disableWindowUnloadingWarning();

            setTimeout(() => {
                window.location.href = "about:blank#end";
            }, 45000);
        }
        this.testTakerService.uploadTestTakerLog();
    }

    ngAfterViewInit() {
        this.testLogoImageData = this.htmlService.getResourceUrl(this.pictureResourceId);
        this.testTakerPhotoUrl = this.testTakerService.getBlankTestTakerPhotoUrl();
        this.testTakerInfoSubscription = this.store.select(fromRoot.getTestTakerInfo).subscribe(testTakerInfo => {
            if (testTakerInfo) {
                this.testTakerPhotoUrl = this.testTakerService.getTestTakerPhotoUrl(testTakerInfo.BrandName, testTakerInfo.TestSessionSiteCode, testTakerInfo.TestTakerId);
                this.testTypeName = testTakerInfo.TestTypeName;
                this.changeDetectorRef.markForCheck();
                this.sendEndOfTestEventToSecureBrowser();
            }
        });
        this.testletIdSubscription = this.store.select(fromRoot.getCurrentTestletId).subscribe(currentTestletId => {
            this.testNavigationService.indicateEndOfTest(currentTestletId);
        });
    }

    ngDestroy() {
        this.testletIdSubscription.unsubscribe();
        this.testTakerInfoSubscription.unsubscribe();
    }

    sendEndOfTestEventToSecureBrowser() {
        const event = new MessageEvent(this.endOfTestEventName, {
            bubbles: true,
            cancelable: false,
            data: ''
        });
        document.dispatchEvent(event);
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/misc/end-of-test/end-of-test.component.ts